import Box from '@amzn/meridian/box';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Profile } from '../../../Types';
import Divider from '@amzn/meridian/divider';
import Row from '@amzn/meridian/row';
import UserInfoSelect from '../../Dashboard/DashboardComponents/UserInfoSelect';
import { renderUrl, urls, weeksList } from '../../../Util';
import { TRAILING_DAYS } from '../../Dashboard/DashboardComponents/LighthouseMetrics/types';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import TrainingCatalog from '../Catalog/TrainingCatalog';
import { useNavigate, useParams } from 'react-router';

interface TrainingAssignmentProps {
  profile: Profile;
}

const TrainingAssignment: React.FC<TrainingAssignmentProps> = ({ profile }) => {
  // Call Training Catalog here to fetch the catalog data
  const { userId } = useParams<{ userId?: string }>();
  const selectedUser = profile.directReports.find(
    report => report.userID === userId
  );
  const navigate = useNavigate();

  return (
    <Box spacingInset='400 500 500 500'>
      <Row alignmentHorizontal='start' alignmentVertical='top'>
        <UserInfoSelect
          givenName={profile.user.displayName}
          username={profile.user.userName}
          weeks={weeksList()}
          selectedWeek={TRAILING_DAYS}
        />
      </Row>
      <Divider spacingAfter='400' />
      <Row alignmentHorizontal='start' alignmentVertical='top'>
        <BreadcrumbGroup>
          {!selectedUser ? (
            <Breadcrumb
              href={`${renderUrl(`${urls.training}`)}`}
              onClick={navigate}
            >
              <FormattedMessage
                id='cs_perfportal_training_assigment_breadcrumb_my_team'
                defaultMessage='My team ({count} associates)'
                values={{ count: profile.directReports.length }}
              />
            </Breadcrumb>
          ) : (
            // @TODO - Implement the functionality that allow TMs back to training page with selected profile open (Dependency: Assigned Training Table)
            <Breadcrumb
              href={`${renderUrl(`${urls.training}/${selectedUser.userID}`)}`}
              onClick={navigate}
            >
              {selectedUser.displayName}
            </Breadcrumb>
          )}
          <Breadcrumb>
            <FormattedMessage
              id='cs_perfportal_training_assigment_assign_new_training'
              defaultMessage='Assign new training'
            />
          </Breadcrumb>
        </BreadcrumbGroup>
      </Row>
      <TrainingCatalog profile={profile} />
    </Box>
  );
};

export default TrainingAssignment;
